import React from "react";

export default function SideBarMenu({ children }) {
  return <ul className="menu">{children}</ul>;
}
